var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOldPeopleSupporters = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Old-People-Man-3--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Old People Man 3 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21 18.37a0.26 0.26 0 0 0 -0.13 -0.22A18.57 18.57 0 0 0 11.5 16C5.66 16 2.39 17.83 1 18.92a2.45 2.45 0 0 0 -1 2v2.58a0.5 0.5 0 0 0 0.5 0.5h8.65a0.25 0.25 0 0 0 0.24 -0.18L11 18.11a0.52 0.52 0 0 1 1 0l1.63 5.71a0.25 0.25 0 0 0 0.24 0.18h6.9a0.25 0.25 0 0 0 0.25 -0.25Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.43 10a1 1 0 0 0 0.57 -0.93V4.88a1.51 1.51 0 0 0 -1.31 -1.49h-0.09a0.25 0.25 0 0 1 -0.2 -0.14 7 7 0 0 0 -11.78 0 0.25 0.25 0 0 1 -0.2 0.14h-0.11A1.51 1.51 0 0 0 4 4.88v4.19a1 1 0 0 0 0.53 0.88s0 0 0 0.07a7 7 0 0 0 13.85 0Zm-6.93 4a5 5 0 0 1 -5 -4.73l0.25 -0.18a3.46 3.46 0 0 0 1.5 -2.16L8.68 5a1.5 1.5 0 0 0 -0.35 -1.33l-0.08 -0.08a0.25 0.25 0 0 1 -0.09 -0.19 0.34 0.34 0 0 1 0.09 -0.19 5 5 0 0 1 6.5 0 0.27 0.27 0 0 1 0.08 0.19 0.21 0.21 0 0 1 -0.08 0.19l-0.08 0.08A1.5 1.5 0 0 0 14.32 5l0.43 1.94a3.46 3.46 0 0 0 1.48 2.15l0.25 0.18A5 5 0 0 1 11.5 14Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.5h2a0.5 0.5 0 0 0 0 -1h-2a0.5 0.5 0 0 0 0 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.5h2a0.5 0.5 0 0 0 0 -1h-2a0.5 0.5 0 0 0 0 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.02a1 1 0 1 0 2 0 1 1 0 1 0 -2 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 9.02a1 1 0 1 0 2 0 1 1 0 1 0 -2 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.58 11.13h-2a0.63 0.63 0 0 0 -0.62 0.48 0.62 0.62 0 0 0 0.31 0.72 2.14 2.14 0 0 0 0.44 0.18 2.91 2.91 0 0 0 0.87 0.13 2.78 2.78 0 0 0 0.87 -0.13 1.63 1.63 0 0 0 0.43 -0.18 0.64 0.64 0 0 0 0.32 -0.72 0.65 0.65 0 0 0 -0.62 -0.48Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 20.89V23a1 1 0 0 0 2 0v-8.25a3.25 3.25 0 0 0 -6.5 0v0.75a1 1 0 0 0 2 0v-0.75a1.25 1.25 0 0 1 2.5 0v6.14Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOldPeopleSupporters);
export default ForwardRef;